import { sendSESEmailWithAttachments } from "../integrations/SESEmail"
import { typeForFilename } from "./Documents"

const defaultFrom = 'no-reply@aws.legal25.com'
const defaultText = 'This is the text version of an HTML email. Your email client does not support HTML emails.'

export async function sendEmailTo(from: string, to: string, cc: string, bcc: string, subject: string, text?: string, html?: string, attachments?: IncomingAttachment[]): Promise<string> {
    const emailAttachments = attachments?.map(a => ({
        contentType: typeForFilename(a.name),
        fileName: a.name,
        base64: a.base64
    })) || []
    console.log('attachments', attachments, emailAttachments)

    return await sendSESEmailWithAttachments(from ?? defaultFrom, to, cc, bcc, subject, text ?? defaultText, html, emailAttachments)
}

interface IncomingAttachment { 
    name: string, 
    base64: string,
}
interface Attachment { 
    contentType: string, 
    fileName: string, 
    base64: string,
}

export interface Email {
    from   ?: string,
    to      : string,
    cc     ?: string,
    bcc    ?: string,
    subject : string,
    text   ?: string,
    html   ?: string,
    attachments?: Attachment[],
}
